var _rect, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaidTagIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 10,
    viewBox: "0 0 22 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 20.6667,
    height: 9,
    rx: 1.5,
    stroke: "#22E295"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.97272 3.18896C6.24568 3.18896 6.48198 3.23989 6.68161 3.34174C6.88531 3.43952 7.0442 3.58008 7.15827 3.76341C7.27235 3.94674 7.32938 4.16471 7.32938 4.4173C7.32938 4.66989 7.27235 4.88785 7.15827 5.07119C7.0442 5.25452 6.88531 5.39711 6.68161 5.49896C6.48198 5.59674 6.24568 5.64563 5.97272 5.64563H5.03772V7.2223H4.54883V3.18896H5.97272ZM5.89938 5.1873C6.21716 5.1873 6.44938 5.12211 6.59605 4.99174C6.74272 4.8573 6.81605 4.66582 6.81605 4.4173C6.81605 4.16471 6.74272 3.97322 6.59605 3.84285C6.44938 3.71248 6.21716 3.6473 5.89938 3.6473H5.03772V5.1873H5.89938Z",
    fill: "#03AB70"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.48522 7.2223L9.05577 3.18896H9.63633L11.2008 7.2223H10.6813L9.53244 4.21563L9.343 3.65341H9.33077L9.15355 4.1973L7.99855 7.2223H7.48522ZM8.25522 6.10396V5.64563H10.4124V6.10396H8.25522Z",
    fill: "#03AB70"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5095 3.18896V7.2223H12.0206V3.18896H12.5095Z",
    fill: "#03AB70"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1306 3.18896C15.762 3.18896 16.257 3.36415 16.6156 3.71452C16.9781 4.06082 17.1594 4.55785 17.1594 5.20563C17.1594 5.85341 16.9781 6.35248 16.6156 6.70285C16.257 7.04915 15.762 7.2223 15.1306 7.2223H13.8289V3.18896H15.1306ZM15.1794 6.76396C15.6398 6.76396 15.9983 6.62748 16.255 6.35452C16.5157 6.07748 16.6461 5.69452 16.6461 5.20563C16.6461 4.71674 16.5157 4.33582 16.255 4.06285C15.9983 3.78582 15.6398 3.6473 15.1794 3.6473H14.3178V6.76396H15.1794Z",
    fill: "#03AB70"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaidTagIcon);
export default __webpack_public_path__ + "static/media/paid-tag-icon.5164a321.svg";
export { ForwardRef as ReactComponent };